import { render, staticRenderFns } from "./HomeSidebarComponent.vue?vue&type=template&id=12bf0d39&"
import script from "./HomeSidebarComponent.vue?vue&type=script&lang=js&"
export * from "./HomeSidebarComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports